/**
 * useFeatureFlag — toggle-on-off feature flag hook.
 *
 * Wraps a Convex query against the featureFlags table with the by_name_and_env
 * index. Returns undefined while the query is loading, then boolean.
 *
 * Toggle-on-off model (no rolloutPercent bucketing — the featureFlags schema
 * does not include a rolloutPercent field). See verification/day1_info.md I-7b.
 *
 * Environment is hardcoded to "prod" to match the seeded featureFlags rows
 * (see scripts/seed-feature-flags.jsonl and convex/features.ts patterns).
 */
import { useQuery } from "convex/react";
import { api } from "../../../../../convex/_generated/api";

/**
 * Check whether a named feature flag is enabled.
 *
 * @param flagName - The feature flag name (e.g. "brief_analyzer_v1").
 * @returns `undefined` while the underlying Convex query is loading,
 *          `true` if the flag is enabled, `false` otherwise.
 */
export function useFeatureFlag(flagName: string): boolean | undefined {
  const result = useQuery(api.features.isEnabled, {
    name: flagName,
    environment: "prod",
  });

  // useQuery returns undefined while loading, then the query result.
  // api.features.isEnabled returns boolean (true/false).
  return result;
}
